export const buttonSize = {
  xs: 'tw-daisy-btn-xs',
  sm: 'tw-daisy-btn-sm',
  md: 'tw-daisy-btn-md',
  lg: 'tw-daisy-btn-lg',
  block: 'tw-daisy-btn-block',
}

export const buttonColor = {
  neutral: 'tw-daisy-btn-neutral',
  warning: 'tw-daisy-btn-warning',
  primary: 'tw-daisy-btn-primary',
  secondary: 'tw-daisy-btn-secondary',
  accent: 'tw-daisy-btn-accent',
  ghost: 'tw-daisy-btn-ghost',
  link: 'tw-daisy-btn-link',
  error: 'tw-daisy-btn-error',
}

export const iconSize = {
  xs: 'tw-text-xs',
  sm: 'tw-text-sm',
  base: 'tw-text-base',
  lg: 'tw-text-lg',
}
